import { Col, List, Row } from "rsuite";
import { FaAddressBook } from "react-icons/fa";
import LocationIcon from '@rsuite/icons/Location';

import { useEffect, useRef, useState } from "react";

//import GoogleAddressSerach from "./GoogleAdressSerach";
//import { PlaceAutocompleteProps } from "../my-type";
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import type { PlaceSelectProps, Place, PlaceAutocompleteProps } from "../my-type";
import { placeData } from "../service";
import { actionCreators } from "../state";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";


// interface AddressSelectProps {
//   onAddressSelect: (address: string | null) => void;
// }

//const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
//console.log(API_KEY);

export default function AddressSelect({ onPlaceSelect }: PlaceSelectProps) {
  const [selectedPlace, setSelectedPlace] =
    useState<google.maps.places.PlaceResult | null>(null);
  const dispatch = useDispatch();
  const { updatePlace } = bindActionCreators(actionCreators, dispatch);
  const placeList = placeData();


  useEffect(() => {
    if (selectedPlace) {
      let postCode: string | undefined = selectedPlace.address_components?.find((element) => element.types[0] === 'postal_code')?.short_name;
      let clonedList = [...placeList];
      let postCodeLength = 0;
      if (postCode) {
        postCodeLength = postCode.length;
      }
      //check address is in service area
      let addressComponents = selectedPlace.address_components;
      if (addressComponents) {
        let country = '';
        let firstLevel = '';
        let secondLevel = '';
        let thirdLevel = '';
        let roadName = '';
        addressComponents.forEach(element => {
          if (element.types[0] === 'country') {
            country = element.short_name;
          }

          if (element.types[0] === 'administrative_area_level_1') {
            firstLevel = element.long_name;
          }

          if (element.types[0] === 'administrative_area_level_2') {
            secondLevel = element.long_name;
          }

          if (element.types[0] === 'administrative_area_level_3') {
            thirdLevel = element.long_name;
          }

          if (element.types[0] === 'route') {
            roadName = element.long_name;
          }
        });

        if (country !== 'TW') {
          alert('country not in service');
          return;
        }

        let varAddr = selectedPlace.formatted_address?.substring(postCodeLength, selectedPlace.formatted_address.length);
        varAddr = varAddr!.substring(2, varAddr!.length);


        let newPlace: Place = {
          id: selectedPlace.place_id!,
          name: selectedPlace.name!,
          address: varAddr!,
          country: country,
          firstLevel: firstLevel,
          secondLevel: secondLevel,
          thirdLevel: thirdLevel,
          road: roadName
        }

        clonedList.push(newPlace);
        updatePlace(clonedList);
        onPlaceSelect(newPlace);


      } else {
        alert('can not get address components data');
        return;
      }

      // let varAddr = selectedPlace.formatted_address?.substring(postCodeLength, selectedPlace.formatted_address.length);
      // console.log(varAddr);
      // if (varAddr?.startsWith('台灣')) {
      //   varAddr = varAddr.substring(2, varAddr.length);
      // }
      // let newPlace: Place = {
      //   id: selectedPlace.place_id!,
      //   name: selectedPlace.name!,
      //   address: varAddr!
      // }
      // clonedList.push(newPlace);
      // updatePlace(clonedList);
      // onPlaceSelect(newPlace);
    }
  }, [selectedPlace])

  return (
    <div>
      <br></br>
      <Row>
        {/* <Col xs="1" style={{ textAlign: 'right', paddingLeft: '10px' }}><Dot style={{ fontSize: '32px' }} /></Col> */}
        <Col xs={2} md={1}>
          <FaAddressBook style={{ fontSize: '20px' }} />
        </Col>
        <Col xs={22} md={18}><PlaceAutocomplete onPlaceSelect={setSelectedPlace} />
        </Col>

      </Row>

      {placeList.length > 0 && <>
        <br></br>
        <br></br>
        <p style={{ textAlign: 'left' }}><h6>搜尋紀錄</h6></p>
        <br></br>
        <List>
          {placeList.map((place, index) => {
            return (<List.Item key={index} style={{ textAlign: 'left' }} onClick={() => onPlaceSelect(place)}>
              <div style={{ paddingLeft: '2px' }}><LocationIcon />&nbsp;
                <span style={{ color: 'black' }}>{place.name}</span><br></br>
                <span style={{ color: 'gray' }}>{place.address}</span>
              </div>
            </List.Item>
            )
          })}
        </List>
      </>
      }

    </div>)


}


const PlaceAutocomplete = ({ onPlaceSelect }: PlaceAutocompleteProps) => {
  const [placeAutocomplete, setPlaceAutocomplete] =
    useState<google.maps.places.Autocomplete | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const places = useMapsLibrary('places');

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      componentRestrictions: { country: "tw" },
      //fields: ['geometry', 'name', 'formatted_address']
      fields: ['ALL']
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener('place_changed', () => {
      console.log('place_changed fired.');
      console.log(placeAutocomplete.getPlace());
      let placeObj = placeAutocomplete.getPlace();
      //let detailObj = placeAutocomplete.getFields
      console.log(placeObj.adr_address);
      console.log(placeObj);
      if ('formatted_address' in placeObj) {
        onPlaceSelect(placeAutocomplete.getPlace());
      }
    });

  }, [onPlaceSelect, placeAutocomplete]);

  return (
    <div className="autocomplete-container">
      <input style={{ width: '90%' }} ref={inputRef} />
    </div>
  );
};
